// extracted by mini-css-extract-plugin
module.exports = {"tab":"style_tab__1z8V-","selected":"style_selected__1KD9W"};